import { i18n } from '~/utils';

export const INCOTERM_CODES = [
  'CFR',
  'CIF',
  'CIP',
  'CPT',
  'DAP',
  'DDP',
  'DPU',
  'EXW',
  'FAS',
  'FCA',
  'FOB',
] as const;

export type IncotermCode = (typeof INCOTERM_CODES)[number];

/**
 * Incoterms, short for "International Commercial Terms", are standardized trade terms
 * issued by the International Chamber of Commerce (ICC)
 * that regulate the rights and obligations of buyers and sellers in international trade in goods
 */
export const INCOTERMS_I18N_MAP = (): Record<IncotermCode, string> => ({
  CFR: i18n.t(($) => $.incoterm.CFR, { ns: 'contract' }),
  CIF: i18n.t(($) => $.incoterm.CIF, { ns: 'contract' }),
  CIP: i18n.t(($) => $.incoterm.CIP, { ns: 'contract' }),
  CPT: i18n.t(($) => $.incoterm.CPT, { ns: 'contract' }),
  DAP: i18n.t(($) => $.incoterm.DAP, { ns: 'contract' }),
  DDP: i18n.t(($) => $.incoterm.DDP, { ns: 'contract' }),
  DPU: i18n.t(($) => $.incoterm.DPU, { ns: 'contract' }),
  EXW: i18n.t(($) => $.incoterm.EXW, { ns: 'contract' }),
  FAS: i18n.t(($) => $.incoterm.FAS, { ns: 'contract' }),
  FCA: i18n.t(($) => $.incoterm.FCA, { ns: 'contract' }),
  FOB: i18n.t(($) => $.incoterm.FOB, { ns: 'contract' }),
});
